// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "previous-job-label .title{-ms-flex-negative:0;flex-shrink:0}", "",{"version":3,"sources":["webpack://./src/components/candidate/profile/section/previous-job-label/style.scss"],"names":[],"mappings":"AACI,0BACI,mBAAA,CAAA,aAAA","sourcesContent":["previous-job-label {\n    .title {\n        flex-shrink: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
